import { QALITY_TEST_ISSUE_TYPE } from '@qality/common-config/src/constants';
import { ProjectSelectOption } from '@qality/common-model';
import { IssueService, PermissionService } from '@qality/common-service';

export const NO_ISSUE_TYPE = 'NO_ISSUE_TYPE';
const FIELD_REQUIRED_MESSAGE = 'This field is required.';

type Errors = {
  testCycle?: string;
  project?: string;
};

export const SelectCycleValidator = async (values: {
  project: ProjectSelectOption;
  testCycle: {
    label: string;
    projectId: string;
    testCasesCount: number;
    value: number;
  };
}): Promise<Errors> => {
  const errors: Errors = {};

  if (!values.project) {
    errors.project = FIELD_REQUIRED_MESSAGE;
  } else {
    const projectPermissions = await PermissionService.hasProjectPermissions(
      values.project.value,
      ['EDIT_ISSUES']
    );

    if (!projectPermissions.EDIT_ISSUES) {
      errors.project = 'No permission to edit issues.';
    } else {
      const allowedIssueTypes = await IssueService.getCreateIssueMetadata(
        values.project.key
      );
      const isIssueTypeInProject = allowedIssueTypes.some(
        (issueType) => issueType.name === QALITY_TEST_ISSUE_TYPE
      );
      if (!isIssueTypeInProject) {
        errors.project = NO_ISSUE_TYPE;
      }
    }
  }

  if (!values.testCycle) {
    errors.testCycle = FIELD_REQUIRED_MESSAGE;
  }

  return errors;
};
